import {
  NotificationListResponse,
  NotificationModel,
} from "services/notification.service";
import { NotificationRealtimePayload } from "services/notificationSocket.service";

export interface NotificationNavigationState {
  selectedNotificationId?: string;
  orderId?: string | null;
  containerId?: string | null;
  routeId?: string | null;
  transportCostId?: string | null;
  notificationType?: string;
}

export interface NotificationNavigationTarget {
  pathname: string;
  state?: NotificationNavigationState;
}

const resolveNotificationCount = (
  ...values: Array<number | null | undefined>
): number | null => {
  for (const value of values) {
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }
  }

  return null;
};

export const mapRealtimeNotificationToModel = (
  notification: NotificationRealtimePayload,
): NotificationModel => ({
  id: notification.notificationId,
  receiverUserId: notification.receiverUserId,
  senderUserId: notification.senderUserId,
  title: notification.title,
  body: notification.body,
  type: notification.type,
  orderId: notification.orderId,
  containerId: notification.containerId,
  routeId: notification.routeId,
  transportCostId: notification.transportCostId,
  status: notification.status,
  readAt: notification.readAt,
  createdAt: notification.createdAt,
});

export const getNotificationRows = (
  response?: NotificationListResponse | null,
): NotificationModel[] => {
  if (!response) {
    return [];
  }

  const responseData = response.data;

  if (Array.isArray(responseData)) {
    return responseData;
  }

  return responseData?.rows ?? responseData?.items ?? [];
};

export const getNotificationTotalCount = (
  response?: NotificationListResponse | null,
): number | null => {
  if (!response) {
    return 0;
  }

  const responseData = Array.isArray(response.data) ? null : response.data;

  return resolveNotificationCount(
    responseData?.count,
    responseData?.total,
    responseData?.meta?.total,
    responseData?.meta?.count,
    response.count,
    response.total,
    response.meta?.total,
    response.meta?.count,
  );
};

export const getNotificationSummary = (
  state: NotificationNavigationState | null,
): string => {
  if (!state) {
    return "";
  }

  if (state.transportCostId) {
    return "Đang mở từ thông báo chi phí";
  }

  if (state.routeId) {
    return "Đang mở từ thông báo tuyến đường";
  }

  if (state.containerId) {
    return "Đang mở từ thông báo container";
  }

  if (state.orderId) {
    return "Đang mở từ thông báo lệnh";
  }

  return "";
};

export const getNotificationNavigationTarget = (
  notification: NotificationModel,
): NotificationNavigationTarget => {
  const { id, orderId, containerId, routeId, transportCostId, type } =
    notification;

  if (orderId) {
    return {
      pathname: `/command-list/detail/${orderId}`,
      state: {
        selectedNotificationId: id,
        orderId,
        containerId,
        routeId,
        transportCostId,
        notificationType: type,
      },
    };
  }

  return {
    pathname: "/notifications",
    state: {
      selectedNotificationId: id,
      orderId: orderId ?? null,
      containerId: containerId ?? null,
      routeId: routeId ?? null,
      transportCostId: transportCostId ?? null,
      notificationType: type,
    },
  };
};
